<template>
  <div class="log_in">
    <div :class="`log_in_wrapper log_in_wrapper_media ${$store.state.sendConfirmCode ? 'd-none' : ''}`">
      <div>
        <router-link class="mobile_link" :to="{name: 'Register'}">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="#C7FF24" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round"/>
          </svg>
          <span>{{ text('wallet.auth.login.register_link') }}</span>
        </router-link>
        <div class="title">{{ text('wallet.auth.login.login') }}</div>
        <input-mask v-model:phone="phone"/>
        <div class="text">
          {{ text('wallet.auth.login.sms_help') }}
        </div>
      </div>
      <br />
      <div class="error">{{ errorMessage }}</div>
      <YandexCaptcha
          ref="yandexCaptchaRefSend"
          @token-received="onCaptchaTokenReceived"
          @token-expired="onCaptchaTokenExpired"
      />
      <BaseButton @click="sendCode" style="margin-bottom: 12px 0">
        <template #label>
          {{ text('wallet.auth.login.send_code') }}
        </template>
      </BaseButton>
      <div class="text">
        <router-link :to="{name: 'Register'}">
          {{text('wallet.auth.login.new_help')}}
        </router-link>
      </div>
    </div>

    <!-- Identifiction -->
    <div :class="`identifiction ${!$store.state.sendConfirmCode ? 'd-none' : ''}`">
      <AuthIdentification
        v-model:confirmCode="confirmCode"
        :phone="phone"
        @onPrevPage="changeToPrevPage"
        :title="text('wallet.auth.login.enter_code')"
        :description="text('wallet.auth.login.enter_code_descr')"
      />
      <div class="identifiction_error">{{ errorMessage }}</div>
      <BaseButton @click="authLogin" :disabled="confirmCode.length < 4" style="margin: 24px 0">
        <template #label>
          {{ text('wallet.auth.login.enter_btn') }}
        </template>
      </BaseButton>

      <div style="margin: 5px 24px 30px 24px;" class="text" v-if="envName === 'stater'">
        Не приходит код? <br/>
        Обратитесь в службу поддержки: <br/><br/>
        <b>+7 (940) 999-11-33</b>
      </div>

      <YandexCaptcha
        v-if="showYandexCaptchaResend"
        ref="yandexCaptchaRefResend"
        @token-received="onCaptchaTokenReceived"
        @token-expired="onCaptchaTokenExpired"
      />
      <send-again-button
        @click="sendAgainClick"
        :title="text('wallet.auth.login.sms_repeat')"
        style="margin-top: 10px"
        :disabled="showYandexCaptchaResend"
      />
    </div>
    <!-- End identifiction -->
  </div>
</template>

<script>
import InputMask from '@/components/phone_input/InputMask.vue'
import BaseButton from '@/components/base/buttons/BaseButton.vue'
import ConfirmationInput from '@/components/ConfirmationInput.vue'
import AuthIdentification from '@/components/AuthIdentification.vue'
import SendAgainButton from '@/components/SendAgainButton.vue'
import GrokPolicy from '../../components/GrokPolicy.vue'
import YandexCaptcha from '@/components/YandexCaptcha.vue'

export default {
  name: "LogIn",
  components: {
    InputMask,
    BaseButton,
    ConfirmationInput,
    AuthIdentification,
    SendAgainButton,
    GrokPolicy,
    YandexCaptcha,
  },
  mounted() {
    this.errorMessage = ''
  },
  data() {
    return {
      phone: '',
      confirmCode: '',
      errorMessage: '',
      captchaToken: '',
      showYandexCaptchaResend: false,
    }
  },
  watch: {
    captchaToken(v) {
      const { showYandexCaptchaResend } = this
      if (showYandexCaptchaResend && !!v) {
        this.reSendCode()
      }
    }
  },
  methods: {
    onCaptchaTokenReceived(token) {
      this.captchaToken = token
      // console.log('Captcha token received in LogIn:', token)
    },
    onCaptchaTokenExpired() {
      this.captchaToken = ''
      this.errorMessage = 'Время действия капчи истекло. Пожалуйста, пройдите проверку заново.'
    },
    async sendCode() {
      const requestData = {"phone": this.phone}

      // Добавляем токен капчи если он доступен
      if (this.yandexCaptchaEnabled && this.captchaToken) {
        requestData.captcha_token = this.captchaToken
      }

      const {data} = await this.$http.post(
        '/v2/wallet/auth/send_code',
        requestData,
        {
          validateStatus: (status) => (status >= 200 && status < 500)
        }
      )
      if (data.status === "error") {
        this.errorMessage = data.message
        // Сбрасываем состояние капчи при ошибке

      } else {
        this.errorMessage = ''
        this.confirmCode = ''
        this.$store.commit('ConfirmCode')
      }

      if (this.yandexCaptchaEnabled && this.$refs.yandexCaptchaRefSend) {
        this.$refs.yandexCaptchaRefSend.reset()
        this.captchaToken = ''
      }
    },
    sendAgainClick() {
      if (this.yandexCaptchaEnabled) {
        this.showYandexCaptchaResend = true
      } else {
        this.reSendCode()
      }
    },
    async reSendCode() {
      const requestData = {"phone": this.phone}

      // Добавляем токен капчи если он доступен
      if (this.yandexCaptchaEnabled && this.captchaToken) {
        requestData.captcha_token = this.captchaToken
      }

      const {data} = await this.$http.post(
        '/v2/wallet/auth/send_code',
        requestData,
        {
          validateStatus: (status) => (status >= 200 && status < 500)
        }
      )
      if (data.status === "error") {
        this.errorMessage = data.message
      } else {
        this.errorMessage = ''
      }

      if (this.yandexCaptchaEnabled && this.$refs.yandexCaptchaRefResend) {
        this.$refs.yandexCaptchaRefResend.reset()
        this.captchaToken = ''
        this.showYandexCaptchaResend = false
      }
    },
    async authLogin() {
      const {data} = await this.$http.post(
        '/v2/wallet/auth/login',
        {"phone": this.phone, "confirm_code": this.confirmCode},
        {
          validateStatus: () => true
        }
      )

      if (data.status === "error") {
        this.errorMessage = data.message
      } else {
        this.errorMessage = ''
        this.$store.commit('setAuthToken', data.auth_token)
        this.$router.push('/')
      }
    },
    changeToPrevPage() {
      this.confirmCode = ''
      this.$store.commit('ConfirmCode')
    },
  }
}
</script>

<style>

</style>
